<template>
  <v-card
      :height="setHeight"
      class="rounded-xl overflow-hidden"
      outlined
      min-width="100%"
      tile
  >
    <v-card-title>
      <h6
          class="mx-auto text-caption text-uppercase text--secondary"
      >
        Комментарии комиссии
      </h6>
    </v-card-title>
    <v-card-text v-if="data_comment.message_commission" style="height: calc(100% - 20px);" class="overflow-auto">
      <v-row justify="center" no-gutters>
        <v-col cols="12" class="text-center">
          <div class="text-h5">
            {{ data_comment.person }}
          </div>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-chip
              :color="setStatus(type_comment).color"
              small
              outlined
          >
            {{ type_comment }}
            <v-icon size="15px" right>
              {{ setStatus(type_comment).icon }}
            </v-icon>
          </v-chip>
        </v-col>
      </v-row>
      <div v-if="definition_role" class="mt-2">
        <v-card elevation="0" class="my-5 overflow-hidden rounded-xl">
          <v-row>
            <v-col :cols="addit_message.length === 0 ? 12 : 5">
              <v-card elevation="0" class="rounded-xl" outlined>
                <div v-if="tm_status_conf === 'Одобрен'" class="d-flex justify-start position-relative">
                  <v-btn
                      @click="createFileES"
                      elevation="0"
                      class="edit-btn ma-2"
                      x-small
                      fab
                      outlined
                      color="teal"
                  >
                    <v-icon size="15px">
                      fa-download
                    </v-icon>
                  </v-btn>
                </div>
                <v-card-title class="pb-0">
                  Оценочный лист
                </v-card-title>
                <v-list :flat="true" :shaped="true">
                  <template v-for="(section, index) in data_result">
                    <v-list-group
                        v-if="section.content.length > 0"
                        active-class="teal--text"
                        :key="section.id"
                        :value="true"
                        :sub-group="true"
                        :expand="false"
                        no-action
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title class="text-h5">
                            <v-icon
                                :color="setGlobalStatus(section.status_estimation_global).color"
                                size="15px"
                                left
                            >
                              {{ setGlobalStatus(section.status_estimation_global).icon }}
                            </v-icon>
                            {{ setIndexParent(section) + " " + section.parameter_name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-card elevation="0" class="text--secondary text-subtitle-1">
                              <v-icon
                                  v-if="section.comments.length > 0"
                                  color="orange"
                                  size="15px"
                                  left
                              >
                                fa fa-comments
                              </v-icon>
                              {{ section.comments }}
                            </v-card>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <v-list-item
                          v-if="section.content.length > 0"
                          v-for="child_section in section.content"
                          :key="child_section.id"
                      >
                        <v-list-item-content v-if="child_section.name !== 'Консультации'">
                          <v-list-item-title>
                            <v-card class="text-h6">
                              <v-icon
                                  :color="setStatusEstimation(child_section.status_estimation).color"
                                  size="15px"
                                  left
                              >
                                {{ setStatusEstimation(child_section.status_estimation).icon }}
                              </v-icon>
                              {{ setIndexChild(section, child_section) + " " + child_section.name }}
                            </v-card>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-card class="text--secondary text-subtitle-1">
                              <v-icon
                                  v-if="child_section.comments.length > 0"
                                  color="orange"
                                  size="15px"
                                  left
                              >
                                fa fa-comments
                              </v-icon>
                              {{ child_section.comments }}
                            </v-card>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                    <v-list-item v-else>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5">
                          <v-card elevation="0">
                            <v-icon
                                :color="setGlobalStatus(section.status_estimation_global).color"
                                size="15px"
                                left
                            >
                              {{ setGlobalStatus(section.status_estimation_global).icon }}
                            </v-icon>
                            {{ setIndexParent(section) + " " + section.parameter_name }}
                          </v-card>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-card elevation="0" class="text--secondary text-subtitle-1">
                            <v-icon
                                v-if="section.comments.length > 0"
                                color="orange"
                                size="15px"
                                left
                            >
                              fa fa-comments
                            </v-icon>
                            {{ section.comments }}
                          </v-card>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card>
            </v-col>
            <v-col v-if="addit_message.length !== 0" cols="7">
              <v-textarea
                  class="mt-4 rounded-xl"
                  :value="addit_message"
                  readonly
                  auto-grow
                  outlined
                  label="Дополнительно"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div v-else class="mt-6">
<!--        <v-row justify="center">-->
<!--          <v-col cols="6">-->
<!--            <v-text-field-->
<!--                :value="provision_status"-->
<!--                label="Обеспечивание учебного процесса"-->
<!--                no-data-text="Данные отсутствуют"-->
<!--                dense-->
<!--                hide-details-->
<!--                rounded-->
<!--                outlined-->
<!--            ></v-text-field>-->
<!--          </v-col>-->
<!--          <v-col cols="6">-->
<!--            <v-text-field-->
<!--                :value="access_status"-->
<!--                no-data-text="Данные отсутствуют"-->
<!--                label="Размещение в СДО Moodle"-->
<!--                dense-->
<!--                hide-details-->
<!--                rounded-->
<!--                outlined-->
<!--            ></v-text-field>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-textarea
            class="mt-5 rounded-xl"
            :value="addit_message"
            hide-details
            height="350px"
            auto-grow
            readonly
            outlined
            label="Дополнительно"
        ></v-textarea>
      </div>
    </v-card-text>
    <v-card-text v-else style="height: calc(100% - 40px);" class="d-flex justify-center align-center">
      <v-alert
          icon="fa fa-exclamation-circle"
          class="text-h6"
          rounded="xl"
          outlined
          color="teal"
      >
        Комментарии не выбраны или отсутствуют
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapState} from "vuex";
import _ from "lodash";
import EvaluationSheetPDF from "../../../../makepdfs/study/evaluation_sheet_pdf";

export default {
  name: "CardCommentsCommission",
  data: () => ({
    headers_table_annotation: [
      {text: '№', value: 'index', sortable: false, align: "center", filterable: false, divider: true},
      {text: 'Параметр', value: 'parameter_name', sortable: false, align: "start", filterable: false, divider: true},
      {text: '', value: 'data-table-expand'},
    ],
    headers_table_inner: [
      {text: '№', value: 'index', sortable: false, align: "center", filterable: false, divider: true},
      {text: 'Элемент', value: 'name', sortable: false, align: "start", filterable: false, divider: true},
      {text: 'Наличие', value: 'status_estimation', align: "center", sortable: false, filterable: false, divider: true},
    ],
    expanded: [],
  }),
  computed: {
    ...mapState({
      data_comment: state => state.studyEstEukTechMapCommission.data_comment,
      list_disciplines: state => state.studyEstEukTechMapAdditData.list_disciplines,
      technical_map: state => state.studyEstEukTechMap.technical_map,
    }),
    provision_status() {
      return this.data_comment?.message_commission?.data_result?.provision_status
    },
    access_status() {
      return this.data_comment?.message_commission?.data_result?.access_status
    },
    type_comment() {
      return this.data_comment?.message_commission?.type_comment
    },
    addit_message() {
      return this.data_comment?.message_commission?.addit_message
    },
    definition_role() {
      return this.data_comment?.data?.euk_role_person === 3
    },
    data_result() {
      return this.data_comment?.message_commission?.data_result
    },
    setHeight() {
      if (Object.keys(this.technical_map).length > 0) {
        return '500px'
      }
      return '180px'
    },
    tm_status_conf(){
      return this.technical_map?.status_confirmation
    }
  },
  methods: {
    setStatus(status) {
      if (status === 'Одобрение') {
        return {color: 'green', name: 'Одобрено', icon: 'fa fa-check-circle'}
      } else if (status === 'Отклонение') {
        return {color: 'red', name: 'Отклонено', icon: 'fa fa-times-circle'}
      }
    },
    setStatusEstimation(status_estimation) {
      if (status_estimation === 2) {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (status_estimation === 3) {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    setIndexParent(parent_item) {
      let index_parent = _.findIndex(this.data_result, ['parameter_name', parent_item.parameter_name])

      return index_parent + 1
    },
    setIndexChild(parent_item, child_item) {
      let index_parent = _.findIndex(this.data_result, ['parameter_name', parent_item.parameter_name])
      let children_element = _.findIndex(this.data_result[index_parent].content, ['name', child_item.name])

      children_element += 1
      index_parent += 1

      return index_parent + "." + children_element
    },
    setGlobalStatus(status_estimation_global){
      if (status_estimation_global === 2) return {color: 'green', icon: 'fa fa-check-circle'}
      if (status_estimation_global === 3) return {color: 'red', icon: 'fa fa-times-circle'}

      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    createFileES(){
      let discipline = _.find(this.list_disciplines, (disc) => {return disc.id === this.technical_map.list_disciplines[0]})
      let data_comments = _.find(this.technical_map.commission, (commission) => {return commission.data.euk_role_person === 3}).message_commission.data_result

      EvaluationSheetPDF.createPDF(this.technical_map, discipline.name, data_comments)
    }
  }
}
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
.edit-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.edit-mode-text {
  position: absolute;
  top: 17px;
  right: 55px;
}
</style>